const se = {
  "lines": [
    "Psst! Leatgo juo gávdnan mu?",
    "Bø! Dušše geahčan movt manná.",
    "Ale muital geasage ahte mun lean dás …",
    "Mun hádjen vafeliid juogo sajis …",
    "Leatgo oaidnán mu gorži?",
    "Šš … mun čiehkádan stálubivdiin!",
    "Joatkke dušše — mun oainnán du!",
    "Leago juo guovvamánu 1. beaivi?"
  ],
  "giant": [
    "BURES DOPPE VUOLDE!",
    "Gii dat scrolle mu šaldi alde?",
    "Mun in leat stuoris. Don leat unni."
  ],
  "golden": "Don oidnet golleastálu! Dušše moatti lihkolaš oaidná mu.",
  "goldenTag": "Legendárálaš"
};

export default se;
